import { Card, CardBody, Col, FormGroup, Input, Table } from "reactstrap";
import { RecentCustomersTitle } from "../../../../../Constants/Constants";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { RecentOrdersTableBody } from "./RecentOrdersTableBody";

const RecentOrders = () => {
  return (
    <Col xl="7" md="12">
      <Card className="recent-order">
        <DashboardCommonHeader title={RecentCustomersTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div className="table-responsive custom-scrollbar">
            <Table className="last-orders-table custom-scrollbar" id="recent-orders">
              <thead>
                <tr>
                  <th className="checkbox-checked">
                    <FormGroup check>
                      <Input type="checkbox" />
                    </FormGroup>
                  </th>
                  <th>Product Name</th>
                  <th>Date &amp; Time </th>
                  <th>Customer</th>
                  <th>Price </th>
                  <th>Status</th>
                  <th>Action </th>
                </tr>
              </thead>
              <RecentOrdersTableBody />
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RecentOrders;
